import { DEFAULT_LOCALE } from 'shared/consts'
import store from 'shared/store'
import { RX_BY_PRINCIPLE_MODAL_CONTAINER_ID } from 'views/containers/browser/RxByPrincipleModalContainer/index'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'
import buildClientAPI from 'views/providers/clientAPI'

const mountRxByPrincipleModalContainer = async () => {
  const container = document.querySelector(
    `#${RX_BY_PRINCIPLE_MODAL_CONTAINER_ID}`
  )

  if (!container) {
    return
  }

  const {
    publicConfig: { locale = DEFAULT_LOCALE },
  } = store.getPublicRuntimeConfig()

  const { cartService } = buildClientAPI()

  const [{ default: renderRxByPrincipleModalContainer }, i18n, response] =
    await Promise.all([
      import(
        /* webpackChunkName: "RxByPrincipleModalContainerWithRenderer", webpackPrefetch: true */
        './RxByPrincipleModalContainerWithRenderer'
      ),
      loadCatalogs(locale),
      cartService.fetchMetadata(),
    ])

  renderRxByPrincipleModalContainer({
    container,
    i18n,
    offerIdsWithAlreadySelectedReasons:
      response.data.rxByPrinciple?.offerIdsWithAlreadySelectedReasons,
  })
}

export default mountRxByPrincipleModalContainer
